module.exports = __webpack_public_path__ + "img/biominder-tray-wire.046d9400.png";